import * as swcHelpers from '@swc/helpers';

function getInitialLensPack(lensPackData, selector) {
    const selection = lensPackData.find((pack)=>pack.pack.key === selector
    );
    return selection ? selection : lensPackData[0];
}
function findAndSortBenefits(packs, sorting) {
    const map = sorting.reduce((main, value, index)=>swcHelpers.objectSpread({}, main, {
            [value]: index
        })
    , {});
    return packs.map((pack)=>{
        const benefits = pack.benefitAttributes.filter((attr)=>/(cb[A-Z])\w+/.exec(attr.name) && attr.name in map
        ).sort((a, b)=>map[a.name] - map[b.name]
        );
        if (!benefits) {
            return swcHelpers.objectSpread({}, pack, {
                benefits: []
            });
        }
        return swcHelpers.objectSpread({}, pack, {
            benefits
        });
    });
}

export { findAndSortBenefits, getInitialLensPack };
//# sourceMappingURL=lens-pack.js.map
